import React from 'react';
import { Button } from 'antd';
import { closeManageSubscriptionModal } from 'utils/globalLayerControl';
import s from './s.module.less';
import { useNavigate } from 'react-router-dom';
import { PATH } from 'constants/path';

const ManageServiceBanner = (props: { isFinish?: boolean }) => {
    const navigate = useNavigate();

    return (
        <div className={s.wrapper}>
            <div className={s.title}>Manage your service templates</div>
            <div className="mb-6">Review or update your service templates based on the conditions you treat, your licenses, and practice states. </div>
            <Button
                type="primary"
                onClick={() => {
                    navigate(`${PATH.SERVICE_SETTING}`);
                    closeManageSubscriptionModal();
                }}
            >Manage
            </Button>
        </div>
    );
};

export default ManageServiceBanner;
